<template>
  <div class="main">
    <TabListCon :divType="divTypes"></TabListCon>
    <img src="../../static/imgs/lsny.jpg" class="img" />
    <!-- <div class="titleText">
      <div class="title">绿色建筑</div>
      <div class="textMs">让高品质民居走进千家万户</div>
    </div> -->
    <div class="box">
      <div class="titleName">产品详情</div>
      <div class="detailsMain">
        <div class="details">
          <div class="detailsNameList" v-for="(item, inx) in detailsData" :key="inx" @click="handleDetailsName(inx)">
            <div :class="index == inx ? 'line' : 'lineNo'"></div>
            <div :class="index == inx ? 'detailsNameBlok' : 'detailsName'">{{ item.name }}</div>
          </div>
        </div>
        <!-- 按切换获取图片 -->
        <img src="../../static/imgs/hy.png" v-if="index == 1" />
        <img src="../../static/imgs/gsy.png" v-if="index == 0" />
        <img src="../../static/imgs/zx.png" v-if="index == 2" />
      </div>
    </div>
    <div v-if="index == 0">
      <img src="../../static/imgs/js6.jpg" class="jsImg" />
      <img src="../../static/imgs/js7.jpg" class="jsImg" />
      <img src="../../static/imgs/js8.jpg" class="jsImg" />
      <img src="../../static/imgs/js9.jpg" class="jsImg" />
    </div>
    <div v-if="index == 1">
      <img src="../../static/imgs/js1.jpg" class="jsImg" />
      <img src="../../static/imgs/js2.jpg" class="jsImg" />
      <img src="../../static/imgs/js3.jpg" class="jsImg" />
    </div>
    <div v-if="index == 2">
      <img src="../../static/imgs/js10.jpg" class="jsImg" />
      <img src="../../static/imgs/js2.jpg" class="jsImg" />
      <img src="../../static/imgs/js3.jpg" class="jsImg" />
    </div>

    <img src="../../static/imgs/js4.jpg" class="jsImg" />
    <img src="../../static/imgs/js5.jpg" class="jsImg" />
    <!-- <div class="productAdvantages">
      <img src="../../static/imgs/C61.png" />
    </div>
    <div class="boxCont">
      <div class="title">户用光伏相比普通理财产品的优点</div>
      <div class="advantageList">
        <div class="advantageCont">
          <img src="../../static/imgs/money1.png">
          <div class="moneyName">收益高</div>
          <div class="moneyText">相比其他无风险收益产品5%左右的收益率户用光伏收益率可达13%，最高可达20%</div>
        </div>
        <div class="advantageCont">
          <img src="../../static/imgs/money2.png">
          <div class="moneyName">收益期长</div>
          <div class="moneyText">25-30年稳定发电收益。这里的文案可以再长一点再长一点再长一点可以再长一点再长一点再长一点</div>
        </div>
      </div>
      <div class="customerCasesMain">
        <div class="customerCasesTitle">客户案例</div>
        <div class="customerCasesMainText">
          以山东省滨州市户用光伏项目为例，脱硫煤电价为0.3949元/度，该屋顶为平屋顶，单户装机容量30KW，发电系数为1.45，年发电量为43500度，融资租赁金额12.6万元，运行周期25年，“全额上网”投资模式，收益如下：
        </div>
      </div>
      <div class="timeNumber">
        <div class="timeTextList">
          <div class="timeText">时间</div>
          <div class="timeText">第一年</div>
          <div class="timeText">1～12年</div>
          <div class="timeText">13年</div>
          <div class="timeText">13～25年</div>
          <div class="timeText">1～25年</div>
        </div>
        <div class="timeTextList">
          <div class="timeText">发电收益</div>
          <div class="timeTextNoCol">1223.12元</div>
          <div class="timeTextNoCol">8814.46元</div>
          <div class="timeTextNoCol">156541.21元</div>
          <div class="timeTextNoCol">20468.45元</div>
          <div class="timeTextNoCol">255555621.24元</div>
        </div>
      </div>
      <div class="customerCasesMainText">
        以山东省滨州市户用光伏项目为例，脱硫煤电价为0.3949元/度，该屋顶为平屋顶，单户装机容量30KW，发电系数为1.45，年发电量为43500度，融资租赁金额12.6万元，运行周期25年，“全额上网”投资模式，收益如下：
      </div>
      <div class="customerCasesMainText">
        计算公式:全额上网收益=发电量x当地脱硫煤电价
      </div>
    </div>
    <img src="https://img01.yzcdn.cn/vant/cat.jpeg" class="flowPathImg" /> -->
    <!-- <BottomContentCon></BottomContentCon> -->
  </div>
</template>
<script>
import TabListCon from "../../components/TabList/index.vue"
import BottomContentCon from "../../components/BottomContent/index.vue"
export default {
  name: "Home",
  data() {
    return {
      index: 0,
      detailsData: [{ name: '工商业光伏', index: 0 }, { name: '户用光伏', index: 1 }, { name: '整县推进', index: 2 }],
      divTypes: '3',//顶部Tab组件的index值
    }
  },
  components: { TabListCon, BottomContentCon },
  created() {

  },
  mounted() {

  },
  methods: {
    handleDetailsName(e) {
      console.log(e)
      this.index = e
    }
  }
};
</script>

<style scoped>
.jsImg {
  width: 100%;
}

.flowPathImg {
  height: 908px;
  margin-top: 160px;
  width: 100%;
}

.timeNumber {
  margin: 0 auto;
}

.timeTextList {
  display: flex;
  align-items: center;
}

.timeText {
  width: 274px;
  height: 85px;
  background-color: #F4F4F4;
  line-height: 85px;
  text-align: center;
  color: #3D3D3D;
  font-size: 21px;
  border: 1px solid #E1E6E6;
}

.timeTextNoCol {
  width: 274px;
  height: 85px;
  background-color: #fff;
  line-height: 85px;
  text-align: center;
  color: #3D3D3D;
  font-size: 21px;
  border: 1px solid #E1E6E6;
}

.customerCasesMainText {
  font-size: 21px;
  color: #6D6D6D;
  text-align: left;
  margin-top: 48px;
  margin-bottom: 48px;
  line-height: 36px;
}

.customerCasesTitle {
  font-family: PingFang SC, PingFang SC;
  font-size: 40px;
  color: #333333;
  font-weight: bold;
}

.customerCasesMain {
  margin-top: 32px;
  padding: 64px;
  text-align: center;
  border: 1px solid #EEEEEE;
}

.advantageList {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.moneyText {
  text-align: center;
  color: #6D6D6D;
  font-size: 21px;
}

.moneyName {
  font-size: 40px;
  color: #333333;
  font-weight: bold;
  text-align: center;
  line-height: 136px;
}

.advantageCont img {
  width: 64px;
  height: 64px;
  display: block;
  margin: 0 auto;
}

.advantageCont {
  padding: 79px 112px;
  width: 784px;
  height: 448px;
  border: 1px solid #EEEEEE;
}

.productAdvantages img {
  width: 100%;
  height: 587px;
}

.boxPhotovoltaicIssues img {
  width: 1600px;
  height: 1020px;
}

.detailsMain img {
  display: block;
  width: 1224px;
  height: 757px;
}

.detailsMain {
  display: flex;
  align-items: start;
  justify-content: space-between;
  padding: 21px 21px 21px 60px;
  background-color: #fff;
}

.detailsName {
  color: #114035;
  font-size: 40px;
  margin-left: 40px;
}

.detailsNameBlok {
  color: #114035;
  font-size: 40px;
  font-weight: bold;
  margin-left: 40px;
}

.line {
  width: 8px;
  height: 40px;
  background: #114035;
}

.detailsNameList {
  margin-top: 64px;
  display: flex;
  align-items: center;
}


.titleName {
  color: #333;
  font-size: 64px;
  text-align: center;
  font-weight: bold;
  padding: 160px 0 108px 0;
}

.name {
  color: #333;
  font-size: 64px;
  text-align: center;
  font-weight: bold;
}

.textMs {
  color: rgba(255, 255, 255, 0.8);
  font-size: 40px;
}

.title {
  color: #fff;
  font-size: 80px;
}

.titleText {
  padding: 145px;
  width: 1500px;
  margin-top: -550px;
  position: absolute;

}

.box {
  padding: 0px 120px 0 120px;
  background: url('../../static/imgs/bg5.png') no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
}

.boxCont {
  padding: 0px 120px 0 120px;
}

.boxPhotovoltaicIssues {
  padding: 120px;
}



.img {
  width: 100%;
  height: 693px;
}
</style>